import AddEntryPage from "./AddEntryPage";

export default AddEntryPage;
